import { defineAsyncComponent, defineComponent } from 'vue';
import UiHeroContent from '@app/components/UI/Hero/Content.vue';
import UiHeroArrow from '@app/components/UI/Hero/Arrow.vue';
import UiHeroMoodVideo from '@app/components/UI/Hero/MoodVideo.vue';
export default defineComponent({
    components: {
        UiHeroContent,
        UiHeroMoodVideo,
        UiHeroFullVideo: defineAsyncComponent(() => import(/* webpackChunkName: "Evolve-Hero-FullVideo" */ '@app/components/UI/Hero/FullVideo.vue')),
        UiHeroArrow,
    },
    props: {
        block: Object,
    },
    data: () => ({
        fullVideoReady: false,
    }),
    computed: {
        logo() {
            return this.$helpers.taggedFirst(this.block.images, 'logo');
        },
    },
});
